// src/pages/Archives.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import toast, { Toaster } from "react-hot-toast";
import { useUserContext } from "../contexts/UserContext";
import { Blocks } from "react-loader-spinner";
import { API_URL } from '../config/api';

export default function Archives() {
  const { user, getAuthHeaders } = useUserContext();
  const [loading, setLoading] = useState(true);
  const [archivedProducts, setArchivedProducts] = useState([]);

const fetchArchivedProducts = async () => {
  if (!user) return;

  try {
    setLoading(true);

    const res = await fetch(`${API_URL}/products/archived/${user._id}`, {
    });
    const data = await res.json();

    setArchivedProducts(data.products || []);
  } catch (err) {
    console.error(err);
    toast.error(err.message || "Erreur récupération articles archivés");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchArchivedProducts();
  }, [user]);

  if (loading) return <div className="loading"><Blocks visible={true} height="80" width="80"/></div>;

  return (
    <>
      <Navbar />
      <Toaster position="top-right" />
      <div className="dashboard-wrapper">
        <h1>Articles Archivés</h1>
        {archivedProducts.length === 0 ? (
          <p>Aucun article archivé pour l'instant.</p>
        ) : (
          <table className="saas-table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Titre</th>
                <th>Catégorie</th>
                <th>Prix</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {archivedProducts.map((product) => (
                <tr key={product._id}>
                  <td>
                    <img 
                      src={product.img.startsWith('http') ? product.img : `http://localhost:8000/uploads/${product.img}`} 
                      alt={product.title} 
                      width="60" 
                    />
                  </td>
                  <td>{product.title}</td>
                  <td>{product.categorie}</td>
                  <td>{Number(product.price).toLocaleString()} FCFA</td>
                  <td>
                    <Link to={`/detailArchive/${product._id}`}>
                      <button className="btn save">Voir détails</button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <Footer />
    </>
  );
}